import React, { useEffect, useState } from "react";
import toastStore from "../../../aps2/stores/ToastStore";
import {
  NfirsFetchStatus,
  useNfirsGetData,
} from "../../../aps2/components/NFIRS/NFIRSHelper";
import ApsServices from "../../../aps2/services";
import ApsModels from "../../../aps2/models";
import commonService from "../../../aps2/services/CommonService";

type State = {
  collapse: boolean;
  ready: boolean;
  departmentSettings?: ApsModels.IDepartmentHomeSettingsOutputDto;
};

const DepartmentHomeSettings = (props: { departmentId: any }) => {
  const [state, setState] = useState<State>({ collapse: true, ready: false });
  const onCollapseChange = () =>
    setState({ ...state, collapse: !state.collapse });

  const getSettings = async () => {
    await ApsServices.http.departmentHomeSettings
      .get(props.departmentId)
      .then((data) => {
        setState({
          ...state,
          ready: true,
          departmentSettings: {
            requiredMonthlyHours: data.requiredMonthlyHours,
          },
        });
        commonService.focusInput("monthlyDrillRequiredHours", 500);
      })
      .catch((err) => {
        toastStore.showError("Failed getting Home Settings", err, undefined, {
          doNothingOn417: true,
        });
        setState({ ...state, collapse: true });
      });
  };

  useEffect(() => {
    if (!state.collapse) {
      getSettings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.collapse]);

  const onSaveClicked = async () => {
    const hours = state.departmentSettings?.requiredMonthlyHours;
    const setAsNull = hours === null || hours === undefined;

    await ApsServices.http.departmentHomeSettings
      .save({
        departmentId: props.departmentId,
        requiredMonthlyHours: setAsNull ? (null as any) : hours,
      })
      .then((settings) => {
        setState({ ...state, departmentSettings: settings });
        toastStore.showToast("Home Settings saved successfully", "success");
      })
      .catch((error) => {
        toastStore.showError(
          "Home Settings were not able to be saved",
          error,
          undefined,
          { doNothingOn417: true }
        );
      });
  };

  const onHoursChanged = (hours: string) => {
    setState({
      ...state,
      departmentSettings: {
        ...state.departmentSettings!,
        requiredMonthlyHours: commonService.isNullOrWhitespace(hours)
          ? (null as any)
          : hours,
      },
    });
  };

  return (
    <div className="flex flex-1 flex-col">
      <div className="container-fluid flex-card-container">
        <div className="flex-0">
          <div className="headerControls">
            <div>
              <span className="pointer" onClick={onCollapseChange}>
                <i
                  className={`fa fa-chevron-${
                    state.collapse ? "up" : "down"
                  } pl-2 pr-2`}
                ></i>
                <h4 className="pt-3 pl-2 m-0 inline-block">Home</h4>
              </span>
            </div>
            <div></div>
          </div>
        </div>
        <div
          className={`doc-designer w-100 pb-4 ${
            state.collapse ? "display-none" : ""
          }`}
        >
          {state.ready ? (
            <>
              <div className="mb-4">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-4 col-xl-3">
                    <div className="pb-0">
                      Monthly Drill Required Hours Per User
                    </div>
                    <input
                      className="form-control"
                      type="number"
                      name="monthlyDrillRequiredHours"
                      id="monthlyDrillRequiredHours"
                      value={state.departmentSettings?.requiredMonthlyHours}
                      onChange={(e) => onHoursChanged(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div>
                <button
                  className="btn btn-primary float-right"
                  onClick={onSaveClicked}
                >
                  <span className="font-size-12">Save</span>
                </button>
              </div>
            </>
          ) : (
            "Loading..."
          )}
        </div>
      </div>
    </div>
  );
};

export default DepartmentHomeSettings;
